import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import ErrorBoundary from '../helpers/ErrorBoundary'
import App from './App'

const Root = ({ store }) => (
  <ErrorBoundary>
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorBoundary>
)

Root.propTypes = {
  store: PropTypes.shape({}).isRequired,
}

export default Root
